import validate from "/opt/build/repo/nuxt/node_modules/.pnpm/nuxt@3.19.1_@netlify+blobs@8.1.2_@parcel+watcher@2.5.1_@types+node@24.3.1_@vue+compiler_9ca5a9b21338589236999b36205589c3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/build/repo/nuxt/node_modules/.pnpm/nuxt@3.19.1_@netlify+blobs@8.1.2_@parcel+watcher@2.5.1_@types+node@24.3.1_@vue+compiler_9ca5a9b21338589236999b36205589c3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  preview: () => import("/opt/build/repo/nuxt/middleware/preview.ts")
}